import { render, staticRenderFns } from "./TopHeader.Collection.vue?vue&type=template&id=2f3822f3&"
import script from "YD/components/topHeader.component.collection?vue&type=script&lang=js&"
export * from "YD/components/topHeader.component.collection?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports